import { keycloak } from "../../../../../lib/keycloak";
import { DatabaseSection, TargetSection } from "../../../../../lib/utils";
import { UserPlusIcon } from "../../../../../ui/icons/userPlus";
import Button from "../../../../../ui/molecules/button";
import { ContactEmployeesResponse } from "../../../../targetList/contacts/dto";
import { PersonDTO } from "../../../people/dto";
import { AccordionEmployee } from "./accordionEmployee";

interface Props {
  employees: PersonDTO[]
  contactEmployees?: ContactEmployeesResponse
  setEmployee: React.Dispatch<React.SetStateAction<PersonDTO | undefined>>;
  companyId?: string
  isInTargetList: boolean;
  navigate: (section: 'list' | 'new' | 'edit') => void;
  section: DatabaseSection | TargetSection;
}

export function CompanyEmployeesList(props: Props) {
  const { employees, navigate, setEmployee, contactEmployees, section } = props

  const employeeList = employees.filter(employee => section !== 'black-list' ? employee.deletedAt === null : true);

  return (
    <div className="h-full">
      <>
        {
          !employeeList || employeeList.length === 0 ?
            <div className="py-4 text-center text-text-sm text-neutral-600 font-semibold">
              Non è stato trovato alcun dipendente per questa azienda.
            </div> :
            <div className="">
              <div className="h-full">
                {employeeList.map((employee) => (
                  <AccordionEmployee
                    key={employee.id}
                    navigate={navigate}
                    setEmployee={setEmployee}
                    isInTargetList={props.isInTargetList}
                    setContactInfo={() => { }}
                    employee={{ ...employee }}
                    contact={contactEmployees ? contactEmployees.employeesContacts.find(c => c.contactId === employee.id) : undefined}
                  />
                ))}
              </div>
            </div>
        }
        <div className="flex flex-col justify-end items-end gap-1 pb-4">
          <div className="h-[1px] w-full bg-neutral-200" />
          <Button
            disabled={keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator')}
            size={"sm"}
            icon={<UserPlusIcon color={""} size={0} />}
            iconPosition={"left"}
            variant={"link"}
            color={"blue"}
            onClick={() => {
              navigate('new');
            }}
            label="Aggiungi nuovo dipendente"
          />
        </div>
      </>
    </div>
  );
}
